
import { Link } from 'react-router-dom';

const AboutHero = () => {
  return (
    <section className="relative min-h-[60vh] sm:min-h-[70vh] lg:min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4ada5c9b71736508894068b2d88afe91.jpg"
          alt="Professional Roofing Team"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3 sm:mb-4 lg:mb-6 font-poppins leading-tight px-4">
          Empowering Homeowners<br className="hidden sm:block" /> Since 2018
        </h1>
        <p className="text-base sm:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto mb-5 sm:mb-6 lg:mb-8 px-4 leading-relaxed">
          We created a better way to connect homeowners with quality roofing professionals. No pushy sales tactics, no middleman markups — just fair pricing and honest work.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 px-4 max-w-md sm:max-w-none mx-auto">
          <a
            href="/contact"
            className="bg-[#2B5BA6] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg font-semibold hover:bg-[#234a8a] transition-colors whitespace-nowrap cursor-pointer text-center min-h-[52px] flex items-center justify-center text-base sm:text-lg"
          >
            Get Started
          </a>
          <a
            href="/services"
            className="bg-white text-[#2B5BA6] px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center min-h-[52px] flex items-center justify-center text-base sm:text-lg"
          >
            Our Services
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
